import PropTypes from 'prop-types';
import {
    List,
    ListItemText,
    Box,
    Avatar,
    Divider,
    Grid2 as Grid,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { EditButton } from '../../../component/buttons';
import { CommonCard } from '../../../component/cards/MainCard2';

const AccountData = ({ user }) => {
    const [role, setRole] = useState(0);
    return (
        <CommonCard sx={{ p: 2 }}>
            <Typography variant="h4">CONTACTOS</Typography>
            <Divider sx={{ mt: 1 }} />
            <List>
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h4" component="span">
                                EMAIL:{' '}
                            </Typography>
                            <Typography variant="body1" component="span">
                                {user.email}
                            </Typography>
                        </>
                    }
                />
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h4" component="span">
                                TELEFONE:{' '}
                            </Typography>
                            <Typography variant="body1" component="span">
                                {user.roles[role].phone}
                            </Typography>
                        </>
                    }
                />
            </List>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <EditButton link={''} name="Editar" size="small" />
            </Box>
            <Box sx={{ height: 16 }} />
            <Typography variant="h4">DADOS CONTA</Typography>
            <Divider sx={{ mt: 1 }} />
            <List>
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h4" component="span">
                                TIMEZONE:{' '}
                            </Typography>
                            <Typography variant="body1" component="span">
                                {user.timezone}
                            </Typography>
                        </>
                    }
                />
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h4" component="span">
                                LOCAL:{' '}
                            </Typography>
                            <Typography variant="body1" component="span">
                                {user.locale}
                            </Typography>
                        </>
                    }
                />
            </List>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <EditButton link={''} name="Editar" size="small" />
            </Box>
        </CommonCard>
    );
};

AccountData.propTypes = {
    user: PropTypes.object
};

export default AccountData;
